import { Map } from 'immutable';

import { shapeVariationsForAPI } from '../../../variations/shapeForAPI';
import { getSize } from '../../../iterable/getSize';

import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../../../constants/channels';
import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { VARIANTS } from '../../../../constants/variations';
import { AMOUNT, VALUE } from '../../../../constants/product';
import { FORM } from '../../../../constants/forms';

import actions from '../../../../actions';

export function variations({ channel, preview }) {
  switch (channel) {
    case EBAY: {
      const result = { actions: [], payload: [] };

      if (preview.getIn([ATTRIBUTE.VARIATIONS, FORM.DETAILS, ATTRIBUTE.ITEM_CATEGORY, VALUE])) {
        const category = preview.getIn([ATTRIBUTE.VARIATIONS, FORM.DETAILS, ATTRIBUTE.ITEM_CATEGORY, VALUE]);
        result.actions.push(actions.bulkEdit.updateMenuForCategory(category));
        result.payload.push(Map({ type: OPERATIONS[EBAY].ITEM_CATEGORY, value: category }));
      }

      if (getSize(preview.getIn([ATTRIBUTE.VARIATIONS, FORM.VARIATIONS, VARIANTS])) > 0) {
        const operation = shapeVariationsForAPI({ product: preview.get(ATTRIBUTE.VARIATIONS), toImmutable: true });
        result.payload.push(operation.set('type', OPERATIONS[EBAY].VARIATIONS));
      }

      return result;
    }

    case ETSY: {
      const result = { actions: [], payload: [] };

      if (
        preview.getIn([ATTRIBUTE.VARIATIONS, FORM.DETAILS, ATTRIBUTE.CATEGORY, VALUE]) &&
        preview.getIn([ATTRIBUTE.VARIATIONS, FORM.DETAILS, ATTRIBUTE.CATEGORY, VALUE]) !== AMOUNT.ZERO
      ) {
        const category = preview.getIn([ATTRIBUTE.VARIATIONS, FORM.DETAILS, ATTRIBUTE.CATEGORY, VALUE]);
        result.actions.push(actions.bulkEdit.updateMenuForCategory(category));

        if (getSize(preview.getIn([ATTRIBUTE.VARIATIONS, FORM.VARIATIONS, VARIANTS])) > 0) {
          const operation = shapeVariationsForAPI({ product: preview.get(ATTRIBUTE.VARIATIONS), toImmutable: true });
          result.payload.push(operation.set('type', OPERATIONS[ETSY].VARIATIONS));
        } else {
          result.payload.push(Map({ type: OPERATIONS[ETSY].CATEGORY, value: category }));
        }
      }

      return result;
    }

    case FAIRE: {
      const result = { payload: [] };

      if (getSize(preview.getIn([ATTRIBUTE.VARIATIONS, FORM.VARIATIONS, VARIANTS])) > 0) {
        const operation = shapeVariationsForAPI({ product: preview.get(ATTRIBUTE.VARIATIONS), toImmutable: true });
        result.payload.push(operation.set('type', OPERATIONS[FAIRE].VARIATIONS));
      }

      return result;
    }

    case SHOPIFY: {
      const result = { payload: [] };

      if (preview.getIn([ATTRIBUTE.VARIATIONS, FORM.DETAILS, ATTRIBUTE.CATEGORY, VALUE])) {
        const category = preview.getIn([ATTRIBUTE.VARIATIONS, FORM.DETAILS, ATTRIBUTE.CATEGORY, VALUE]);
        result.payload.push(Map({ type: OPERATIONS[SHOPIFY].CATEGORY, value: category }));
      }

      if (getSize(preview.getIn([ATTRIBUTE.VARIATIONS, FORM.VARIATIONS, VARIANTS])) > 0) {
        const operation = shapeVariationsForAPI({ product: preview.get(ATTRIBUTE.VARIATIONS), toImmutable: true });
        result.payload.push(operation.set('type', OPERATIONS[SHOPIFY].VARIATIONS));
      }

      return result;
    }

    default: {
      return {};
    }
  }
}
